import React from "react";
import { Button, Modal } from "../../../../components";


const DeleteConformationModal = ({ open, onClose }) => {
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="DELETE CONFORMATION"
      width="max-w-2xl"
    >
      <div className="px-4">
        <div>
          <p>You are about to delete an invoice with the following outcome</p>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <Button title={"No"} variant="outlined" onClick={onClose} />
          <Button title={"Yes"} />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConformationModal;
